export enum BookingOrderStatuses {
  ADDED = "Added to booking",
  READY = "Ready for booking",
}
